
export default {
  name: 'Content',

  props: {
    content: {
      type: [Object, Array],
      required: true
    }
  }
}
